import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import "./save.css";
import cImg2 from "../../assets/images/jobicon.png"; // ✅ fallback image
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import Countdown from 'react-countdown';
import { setJobData, updateJobApplicant } from '../../slice/jobSlice';
import { useApplyJobMutation, useJobDetByIdUserQuery } from '../../slice/authApiSlice';
import { toast } from 'react-toastify';
import { setJob } from '../../slice/updateJobSlice';
import { generatePublicUrl } from '../../config/image';

function DetailsJob() {
  const location = useLocation();
  const { data } = location.state;
  const [applyJob] = useApplyJobMutation();
  const updateJob = useSelector(state => state.updateJob.updateJob);
  const [newJob, setNewJob] = useState(data);
  const { data: jobDetByIdUser } = useJobDetByIdUserQuery(data._id, {
    skip: !data?._id
  });
  const user = useSelector(state => state.auth.userInfo);
  const dispatch = useDispatch();

  const statusMap = {
    notaplied: 0,
    applied: 20,
    'under review': 40,
    shortlisted: 60,
    rejected: 80,
    hired: 100,
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span className="newBiddingTimer1">Job Expired</span>;
    } else {
      return <span className="newBiddingTimer1">{days}d {hours}h {minutes}m {seconds}s left</span>;
    }
  };

  useEffect(() => {
    if (jobDetByIdUser) {
      dispatch(setJob(jobDetByIdUser));
    }
  }, [dispatch, jobDetByIdUser, data?._id]);

  const applicant = newJob?.applicant?.find(app => app.userId === user?._id);
  const isAlreadyApplied = !!applicant;
  const progress = statusMap[applicant?.status] || 0;

  const handleApplyBtn = async () => {
    try {
      const res = await applyJob(data._id).unwrap();
      dispatch(updateJobApplicant({
        jobId: data._id,
        applicant: res.updatedJob.applicant
      }));
      dispatch(setJobData(res.job));
      dispatch(setJob(res.updatedJob));
      setNewJob(res.updatedJob);
      toast.success("Applied successfully");
    } catch (error) {
      alert(error);
    }
  };

  return (
    <section className='sc-det-area-upper'>
      <div className="job-gg">
        <h2>Application status</h2>
        <Box className sx={{ width: '70%' }}>
          <Typography variant="body1" gutterBottom style={{ color: "white" }}>
            {progress === 0 ? 'Progress (Not Applied - 0%)' : `Progress (${applicant?.status} - ${progress}%)`}
          </Typography>
          <LinearProgress
            sx={{ '& .MuiLinearProgress-bar': { backgroundColor: 'white' } }}
            variant="determinate"
            value={progress}
          />
        </Box>
      </div>

      <section className='AppliedJobs'>
        <div className='Applied-inner'>
          <div className='applied-img'>
            <img
              src={
                newJob?.companyDetails?.companyLogo
                  ? generatePublicUrl(newJob.companyDetails.companyLogo)
                  : cImg2
              }
              alt="Company logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = cImg2;
              }}
            />
          </div>

          <section className='mob-det-section-data'>
            <div className='hide-in-desk-strong'>
              <div className='hide-in-desk-strong-img'>
                <img
                  src={
                    newJob?.companyDetails?.companyLogo
                      ? generatePublicUrl(newJob.companyDetails.companyLogo)
                      : cImg2
                  }
                  alt="Company logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = cImg2;
                  }}
                />
              </div>
              <div>Job details in below</div>
            </div>
          </section>

          <div className='applied-desc'>
            <h1>{data?.title} ({data?.companyDetails?.companyName})</h1>
            <h2>Job location: {data?.location}</h2>
            <h3>Number Of Openings: {data?.numPosition}</h3>
            <h3>Job Expired in:
              <Countdown
                date={new Date(data.endDate)}
                autoStart={true}
                renderer={renderer}
              />
            </h3>
            <h3>Description:</h3>
            <p>{data?.description}</p>

            <button
              className={isAlreadyApplied ? 'applied-btn' : 'apply-btn'}
              onClick={handleApplyBtn}
              disabled={isAlreadyApplied}
            >
              {isAlreadyApplied ? 'Already applied' : 'Apply now'}
            </button>
          </div>
        </div>
      </section>
    </section>
  );
}

export default DetailsJob;
